import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Remove this import until we install the package
// import LanguageDetector from 'i18next-browser-languagedetector';
import svTranslation from './locales/sv.json';
import enTranslation from './locales/en.json';
import noTranslation from './locales/no.json';
import daTranslation from './locales/da.json';

// Function to detect country based on IP
const detectUserCountry = async (): Promise<string> => {
  try {
    // Using a free geolocation API
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    return data.country_code; // Returns ISO country code (SE, NO, DK, etc.)
  } catch (error) {
    console.error('Error detecting country:', error);
    return 'UNKNOWN';
  }
};

// Map countries to languages
const countryToLanguage: Record<string, string> = {
  SE: 'sv', // Sweden -> Swedish
  NO: 'no', // Norway -> Norwegian
  DK: 'da', // Denmark -> Danish
  // Default for other countries will be English
};

// Simple language detection without the external package
const detectUserLanguage = async (): Promise<string> => {
  // First check localStorage for saved preference
  const savedLanguage = localStorage.getItem('i18nextLng');
  if (savedLanguage) {
    return savedLanguage;
  }
  
  // If no saved preference, detect by country
  const country = await detectUserCountry();
  return countryToLanguage[country] || 'en'; // Default to English
};

// Initialize i18n without the language detector
i18n
  // Remove the languageDetector usage
  // .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      sv: { translation: svTranslation },
      no: { translation: noTranslation },
      da: { translation: daTranslation }
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Check and set user language on initial load
detectUserLanguage().then(language => {
  i18n.changeLanguage(language);
});

// Create a wrapper for language changes to ensure storage
export const changeLanguage = (language: string) => {
  i18n.changeLanguage(language);
  localStorage.setItem('i18nextLng', language);
};

export default i18n;